<template>
  <div class="certification">
    <van-icon style="position: absolute;top: 18px;left:7px;font-size: 20px" name="arrow-left" @click="backLogin" />
    <Form ref="form">
      <h4 class="cert-tip">
        {{ componentParams.isPay ? componentParams.payMsg : componentParams.cert_msg }}
      </h4>
      <div class="cert-tip" v-if="componentParams.isPay && componentParams.expire_time > 0">
        剩余可试玩时间：{{computeTime(componentParams.expire_time)}}
      </div>
      <Field
        v-model="realname"
        label="姓名"
        placeholder="请输入姓名"
        :rules="[{ required: true, message: '请填写姓名' }]"
      >
      </Field>
      <Field
        v-model="idcard"
        label="身份证"
        placeholder="请输入身份证"
        :rules="[{ required: true, message: '请填写身份证' }]"
      >
      </Field>
      <div class="bottom">
        <Row class="login-row">
          <Button class="login-btn" block type="info" @click="certification">
            实名登记
          </Button>
        </Row>
      </div>
    </Form>
    <van-icon v-if="componentParams.is_close" style="position:absolute;right:0;top:0;right:10px;top:10px;" name="cross" @click="closeWindow" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { Form, Field, Button, Row, Dialog } from 'vant';
import server from '@/server';
import channelServer from '@/server/channelServer';
import statis from '@/server/statis';
import mixServer from '@/server/mixServer';
import { commonMixin } from '@/mixin';
export default {
  name: 'certification',
  mixins: [commonMixin],
  components: { Form, Field, Button, Row },
  data() {
    return {
      realname: '',
      idcard: '',
      type: 0,
      certClickTimer: false
    };
  },
  computed: {
    ...mapState(['componentParams', 'user', 'guestInfo', 'guestLoginData']),
    ...mapGetters(['isForceCert'])
  },
  created() {},
  mounted() {},
  methods: {
    certification() {
      if (this.certClickTimer) clearTimeout(this.certClickTimer)
      this.certClickTimer = setTimeout(() => {
        this.formCheck('form').then(() => {
          const params = {
            realname: this.realname,
            idcard: this.idcard,
            type: this.type
          };
          channelServer.certification(params).then(({ ret, msg, data }) => {
            // 实名登录成功后
            statis.cert([{cert_type: 1, ln_uid: channelServer.ln_uid}]); // 乐牛sdk实名上报
            this.$store.commit('CLOSE');
            if (data.is_allow_online == 0) {
              Dialog({ message: data.cert_msg });
              this.reloadGameFrame();
              this.$store.commit('SHOW', 'Login');
            } else {
              // Dialog({ message: msg });
              localStorage.setItem('agreeProt', true);
              // this.$store.commit('SET_SHOWBIND', 0);
              setTimeout(() => {
                // server.autoLogin();
                mixServer.login(this.guestLoginData);
                // this.$store.commit('SHOW', 'Login');
                // if (this.guestInfo.is_reg == 1) {
                //   this.$store.commit('SHOW', 'SavePassword');
                // }
              }, 100);
            }
            const { isPay, payParams } = this.componentParams || {};
            if (isPay) {
              // 如果是支付跳转过来的，重新拉起支付
              mixServer.pay(payParams);
            } else {
              // 如果需要是强制退出游戏的，重新登录
              if (this.isForceCert) {
                // server.autoLogin();
              }
            }
          });
        });
      }, 500);
    },
    computeTime(time) {
      if (!time) return;
      let remainTime = time - (Date.parse(new Date()) / 1000);
      let min = Math.floor(remainTime / 60);
      if (min < 0) {
        min = 0;
      }
      return min + '分钟';
    },
    closeWindow() {
      this.$store.commit('CLOSE');
    },
    backLogin() {
      this.changeComponent('PhoneLogin');
    },
    reloadGameFrame() {
      const gameFrame = document.querySelector('#gameFrame');
      gameFrame.src = `${gameFrame.src}?v=${new Date().getTime()}`;
    }
  }
};
</script>
<style lang="scss">
/* @import ('url') */
.cert-tip {
  margin: 16px;
  font-size: 14px;
}
</style>
